import React from 'react'

/**
 * The SpotMe brand mark (roof + pin), as inline SVG.
 *
 * Geometry is lifted verbatim from the two icon paths in
 * `public/svgs/spotme.svg` — the same artwork as the wordmark, so this can
 * never drift from the logo. The `viewBox` is that mark's measured bounding
 * box, so the shape sits flush against the box with no baked-in padding:
 * space around it is the caller's to give.
 *
 * Inline rather than `/images/map_icon.png` (1080x1080, 28 KB) or
 * `/images/map_pin_static.png` for two reasons. It costs no request and stays
 * crisp at any DPR — that PNG is 64px and would visibly soften at 2-3x on the
 * mobile devices that are ~90% of our traffic. And it keeps `next/image` off
 * an element that can render server-side, which spotme-client/CLAUDE.md
 * "Hydration Safety" #9 calls out as a #418 trigger for tiny static icons.
 *
 * Fills with `currentColor` so callers tint it with a brand token
 * (`text-blue-500`, `text-white-500`) instead of re-stating the hex — the
 * same convention the logo bands use.
 */
const SpotMeMarker = ({ className }: { className?: string }) => (
  <svg
    viewBox="7.8 15 508.7 447"
    className={className}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    {/* The wordmark's own coordinate flip. Kept as-is so the `d` attributes
        below stay byte-identical to the source artwork. */}
    <g transform="translate(0,507) scale(0.1,-0.1)" stroke="none">
      <path d="M2151 4493 l-421 -427 0 132 c0 73 -1 132 -2 132 -2 -1 -118 -36 -258 -78 l-255 -78 -5 -327 -5 -327 -500 -521 c-275 -287 -528 -552 -563 -590 l-64 -69 225 0 224 0 1031 1025 1030 1025 1014 -989 1013 -990 275 0 275 -1 -45 44 c-1344 1312 -2533 2466 -2539 2466 -5 0 -199 -192 -430 -427z" />
      <path d="M2482 3390 c-314 -44 -553 -224 -689 -517 -136 -295 -101 -686 108 -1187 103 -244 284 -582 454 -847 96 -149 266 -389 276 -389 20 0 225 271 352 466 427 653 616 1272 541 1772 -52 353 -301 616 -649 687 -95 19 -304 27 -393 15z m219 -755 c63 -23 104 -58 133 -117 116 -232 -166 -456 -360 -285 -58 51 -84 105 -84 177 0 163 159 278 311 225z" />
    </g>
  </svg>
)

export default React.memo(SpotMeMarker)
